/* =========================================================================
   MARKETING Hero — Marketing Strategy Wizard: shared types & schema.
   Turns brand + objective + budget into a full strategy blueprint and a
   concrete 30-Day Action Plan.
   ========================================================================= */

export interface StrategyInputs {
  product?: string; service?: string; objective?: string; budget?: string;
  market?: string; target?: string; trafficSource?: string; salesChannel?: string;
  price?: string; offer?: string; currentProblem?: string; name?: string;
}

export const OBJECTIVES = ["Lead / รายชื่อ", "Message / ทักแชต", "Sales / ยอดขาย", "Traffic / คนเข้าเว็บ", "Awareness / การรับรู้", "Engagement"];

export interface StrategyOutput {
  marketSituation: string;
  targetSegment: string;
  persona: string;
  painDesireObjection: { pain: string; desire: string; objection: string; trigger: string };
  positioning: string;
  coreMessage: string;
  offerStrategy: string;
  contentStrategy: string;
  creativeStrategy: string;
  adsStrategy: string;
  channelStrategy: string;
  funnel: string;
  retargeting: string;
  kpis: { metric: string; target: string }[];
  testingPlan: string[];
  actionPlan30: { week: number; focus: string; tasks: string[] }[];
  disclaimer?: string;
}

export const STRATEGY_SCHEMA_HINT = {
  marketSituation: "string",
  targetSegment: "string",
  persona: "string",
  painDesireObjection: { pain: "string", desire: "string", objection: "string", trigger: "string" },
  positioning: "string",
  coreMessage: "string",
  offerStrategy: "string",
  contentStrategy: "string",
  creativeStrategy: "string",
  adsStrategy: "string",
  channelStrategy: "string",
  funnel: "string",
  retargeting: "string",
  kpis: [{ metric: "string", target: "string" }],
  testingPlan: ["string"],
  actionPlan30: [{ week: 1, focus: "string", tasks: ["string"] }],
};
